<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cy">
<p class="cipf"><a class="page" id="piv"></a>Catholic Practice in North America | Angela Alaimo O’Donnell and John C. Seitz, series editors</p>
<p class="cipf">Copyright © 2015 Michael N. McGregor</p>
<p class="cipf">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="cipf">All quotations from Robert Lax’s poetry and other writings are used by permission of the Robert Lax Literary Trust.</p>
<p class="cipf">Excerpts from <i>Seven Storey Mountain</i> by Thomas Merton. Copyright 1948 by Houghton Mifflin Harcourt Publishing Company; copyright © renewed 1976 by the Trustees of The Merton Legacy Trust. Reprinted by permission of Houghton Mifflin Harcourt Publishing Company. All rights reserved.</p>
<p class="cipf">Quotations from Thomas Merton letters first published in <i>When Prophecy Still Had a Voice</i> are reprinted by permission of the Merton Legacy Trust.</p>
<p class="cipf">Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.</p>
<p class="cipf">Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.</p>
<p class="cipf">Visit us online at <a class="url" href="http://www.fordhampress.com" target="_blank">www.fordhampress.com</a>.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">McGregor, Michael N.<br/>
      Pure act : the uncommon life of Robert Lax / Michael N. McGregor. — First edition.<br/>
           pages cm. — (Catholic practice in North America)<br/>
        Includes bibliographical references and index.<br/>
      ISBN 978-0-8232-6801-6 (hardback)<br/>
     1.  Lax, Robert. 2.  Poets, American—20th century—Biography. 3.  Poetry—Authorship.  I. Title.<br/>
      PS3523.A972Z76 2015<br/>
      811'.54—dc23<br/>
      [B]<br/>
                                                                2015009511    <br/></p>
<p class="cipf">First edition</p><a class="page" id="pv"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// McGregor0003.vue?a1b16c08